export default __webpack_public_path__ + "media/images/playpass_logo_h_xsm-f908e48cd8527801752897db7127ae03.png";